(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-old"]) return;
  try {
    
let w= document.documentElement.clientWidth
|| document.body.clientWidth;
if(w > 980){
setBarFixed('main_header')
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

//搜索框select pc
const hd_form_select = document.getElementById('hd_form_select')
const hd_form_input = document.getElementById('hd_form_input')

  hd_form_select.addEventListener('change', function() {
    let selectedValue = this.value; 
    if (selectedValue.indexOf('全ての商品') !== -1) {
        hd_form_input.value = ''
     }else{
       hd_form_input.value = selectedValue
     }

  });

//搜索框select mob
const hd_form_select_mob = document.getElementById('hd_form_select_mob')
const hd_form_input_mob = document.getElementById('hd_form_input_mob')

  hd_form_select_mob.addEventListener('change', function() {
  let selectedValue_mob = this.value; 
    if (selectedValue_mob.indexOf('全ての商品') !== -1) {
        hd_form_input_mob.value = ''
     }else{
       hd_form_input_mob.value = selectedValue_mob
     }
  });
//用户名称缩略
const hd_customer_name = document.getElementById("hd_customer_name");

if(hd_customer_name){
    const hd_customer_name_txt = hd_customer_name.innerText
const newTxt = truncateString(hd_customer_name_txt,8)
hd_customer_name.innerText = newTxt
}

//cp端左侧下拉菜单
const accordion_menu = document.querySelector('.accordion-menu');
const accordion_menu_level = document.querySelector('.accordion-menu-level');
const accordion_menu_uls = accordion_menu.querySelectorAll('ul')
//console.log(accordion_menu_uls)
//一级
accordion_menu.addEventListener('mouseenter', function() {
  event.stopPropagation(); 
    accordion_menu_level.classList.add('d-block');
   //document.body.style.overflow = "hidden"
 
});
accordion_menu.addEventListener('mouseleave', function() {
  event.stopPropagation(); 
    accordion_menu_level.classList.remove('d-block');
   // document.body.style.overflow = "auto"
     accordion_menu_uls.forEach(function(ul) {
       ul.scrollTop = 0
});
});
var main_container = document.getElementById('main--container');
var mob_header_search = document.getElementById('mob_header_search');
let w= document.documentElement.clientWidth
|| document.body.clientWidth;


if(mob_header_search&&w < 993){
window.addEventListener('scroll', function() {
    if (window.scrollY >= 60) {
        mob_header_search.classList.add('f-top');
        main_container.style.marginTop = '55px'
    } else {
        mob_header_search.classList.remove('f-top');
        main_container.style.marginTop = '0'
    }
});

}




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-bottom"]) return;
  try {
    



     let recommend_swiper = new Swiper("#recommend_swiper2", {
     spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".article_recommend_next",
          prevEl: ".article_recommend_pre",
        },
      });
    

 let article_meanwhile = document.getElementById('article_meanwhile');

      let article_meanwhile_swiper = new Swiper("#article_meanwhile", {
     spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".article_meanwhile_next",
          prevEl: ".article_meanwhile_pre",
        },
      });



       let faq_swiper2 = new Swiper("#faq_swiper2", {
        spaceBetween: 0,
        loop: true,
        slidesPerView: 'auto',
        loopedSlides: 5,
        speed:800,
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        },
        freeMode: true,
        watchSlidesProgress: true,
      navigation: {
          nextEl: ".customerFeedback-next-btn",
          prevEl: ".customerFeedback-pre-btn",
        },
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-tag"]) return;
  try {
    
 let recommend_swiper2 = document.getElementById('recommend_swiper2');
 let recommend_pre2 = document.getElementById('recommend_pre2');
 let recommend_next2 = document.getElementById('recommend_next2');
let recommend_swiper2_slides = recommend_swiper2.querySelectorAll('.swiper-slide');
let recommend_swiper2_slidesLength = recommend_swiper2_slides.length

function updateWidth() {


    let browserWidth = window.innerWidth;
    if((browserWidth>992&&recommend_swiper2_slidesLength>4) || (576<browserWidth<=992&&recommend_swiper2_slidesLength>3) || (browserWidth<=576&&recommend_swiper2_slidesLength>2)){
     recommend_pre2.style.display = ""
      recommend_next2.style.display = ""
      let article_recommend_swiper2 = new Swiper("#recommend_swiper2", {
        spaceBetween: 0,
        loop: true,
        slidesPerView: 'auto',
        loopedSlides: 5,
        speed:800,
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        },
        freeMode: true,
        watchSlidesProgress: true,
      navigation: {
          nextEl: ".recommend-next-btn",
          prevEl: ".recommend-pre-btn",
        },
      });
    }else{
      recommend_pre2.style.display = "none";
      recommend_next2.style.display = "none";
    }

}
updateWidth()


window.addEventListener('resize', updateWidth);


       let customerFeedback_swiper2 = new Swiper("#customerFeedback_swiper2", {
        spaceBetween: 0,
        loop: true,
        slidesPerView: 'auto',
        loopedSlides: 5,
        speed:800,
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        },
        freeMode: true,
        watchSlidesProgress: true,
      navigation: {
          nextEl: ".customerFeedback-next-btn",
          prevEl: ".customerFeedback-pre-btn",
        },
      });




       let left_media_dom = document.getElementById('left_media')
            if (left_media_dom) {
            const left_media_width = left_media_dom.offsetWidth
            const left_media_size = parseInt(left_media_dom.dataset.size)
            const innerWidth = window.innerWidth
            const itemW = innerWidth > 992 ? 160 : 150
            const slidesW = itemW * left_media_size
             if(slidesW > left_media_width){
                 new Swiper("#media_swiper", {
                spaceBetween: 10,
                slidesPerView: "auto",
                freeMode: true,
                watchSlidesProgress: true,
                loop: true,
                    speed:800,
                    autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                    },
                });
             }else{
                left_media_dom.classList.add('noSwiperDom')
             }
            }






  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
     var article_recommend_swiper = new Swiper("#recommend_swiper", {
        spaceBetween: 0,
        slidesPerView: 'auto',
        loopedSlides: 5,
        speed:800,
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        },
        freeMode: true,
        watchSlidesProgress: true,
      navigation: {
          nextEl: ".recommend-next-btn",
          prevEl: ".recommend-pre-btn",
        },
      });
       let left_media_dom = document.getElementById('left_media')
            if (left_media_dom) {
            const left_media_width = left_media_dom.offsetWidth
            const left_media_size = parseInt(left_media_dom.dataset.size)
            const innerWidth = window.innerWidth
            const itemW = innerWidth > 992 ? 160 : 150
            const slidesW = itemW * left_media_size
             if(slidesW > left_media_width){
                 new Swiper("#media_swiper", {
                spaceBetween: 10,
                slidesPerView: "auto",
                freeMode: true,
                watchSlidesProgress: true,
                loop: true,
                    speed:800,
                    autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                    },
                });
             }else{
                left_media_dom.classList.add('noSwiperDom')
             }
            }

       let faq_swiper2 = new Swiper("#faq_swiper2", {
        spaceBetween: 0,
        loop: true,
        slidesPerView: 'auto',
        loopedSlides: 5,
        speed:800,
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        },
        freeMode: true,
        watchSlidesProgress: true,
      navigation: {
          nextEl: ".customerFeedback-next-btn",
          prevEl: ".customerFeedback-pre-btn",
        },
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-faq"]) return;
  try {
    
       let faq_swiper2 = new Swiper("#faq_swiper2", {
        spaceBetween: 0,
        loop: true,
        slidesPerView: 'auto',
        loopedSlides: 5,
        speed:800,
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        },
        freeMode: true,
        watchSlidesProgress: true,
      navigation: {
          nextEl: ".customerFeedback-next-btn",
          prevEl: ".customerFeedback-pre-btn",
        },
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-files"]) return;
  try {
    



       let filesSwiper = new Swiper("#filesSwiper", {
        spaceBetween: 0,
        loop: true,
        slidesPerView: 'auto',
        loopedSlides: 5,
        speed:800,
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        },
        freeMode: true,
        watchSlidesProgress: true,
         navigation: {
          nextEl: ".customerFeedback-next-btn",
          prevEl: ".customerFeedback-pre-btn",
        },
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-kol"]) return;
  try {
    
 const aside_product = document.getElementById("aside-product")
 if (aside_product) {
    var aside_product_swiper = new Swiper("#aside-product", {
    direction: "vertical",
    slidesPerView: "auto",
    spaceBetween: 10,
    speed:500,
    loop: true,
    autoplay: {
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: true,
    },
    freeMode: true,
    watchSlidesProgress: true,
    });
 }

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-video"]) return;
  try {
    
recommendSwiper('#product_swiper')

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    let rsiBuy = document.getElementById('_rsi-buy-now-button');
    if(rsiBuy){
 rsiBuy.style.cssText = "background:#e05266;"
    }
   
    const giftCont = document.querySelector('.sns-gift-new-cart-container');
    if(giftCont){
        giftCont.classList.add('container-lg');
    }

});


  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);
  var customerFeedback_swiper2 = new Swiper("#customerFeedback_swiper", {
     spaceBetween: 10,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".customerFeedback-next-btn",
          prevEl: ".customerFeedback-pre-btn",
        },
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-discount"]) return;
  try {
    
 var meanwhile_swiper = new Swiper("#meanwhile_swiper", {
     spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".meanwhile-next-btn",
          prevEl: ".meanwhile-pre-btn",
        },
      });
 var recommend_swiper = new Swiper("#recommend_swiper", {
     spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".recommend-next-btn",
          prevEl: ".recommend-pre-btn",
        },
      });
     var customerFeedback_swiper = new Swiper("#customerFeedback_swiper", {
     spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".customerFeedback-next-btn",
          prevEl: ".customerFeedback-pre-btn",
        },
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-list"]) return;
  try {
    

    //  var popularity_swiper = new Swiper("#popularity_swiper", {
    //   spaceBetween: 0,
    //   slidesPerView: "auto",
    //   freeMode: true,
    //   watchSlidesProgress: true,
    //   navigation: {
    //       nextEl: ".popularity-next-btn",
    //       prevEl: ".popularity-pre-btn",
    //     },
    //   });
 var meanwhile_swiper = new Swiper("#meanwhile_swiper", {
     spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".meanwhile-next-btn",
          prevEl: ".meanwhile-pre-btn",
        },
      });
 var recommend_swiper = new Swiper("#recommend_swiper", {
     spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".recommend-next-btn",
          prevEl: ".recommend-pre-btn",
        },
      });
     var customerFeedback_swiper = new Swiper("#customerFeedback_swiper", {
    spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".customerFeedback-next-btn",
          prevEl: ".customerFeedback-pre-btn",
        },
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
 var meanwhile_swiper = new Swiper("#meanwhile_swiper", {
     spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".meanwhile-next-btn",
          prevEl: ".meanwhile-pre-btn",
        },
      });
 var recommend_swiper = new Swiper("#recommend_swiper", {
     spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".recommend-next-btn",
          prevEl: ".recommend-pre-btn",
        },
      });
     var customerFeedback_swiper = new Swiper("#customerFeedback_swiper", {
     spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".customerFeedback-next-btn",
          prevEl: ".customerFeedback-pre-btn",
        },
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-index_benfen"]) return;
  try {
    

    var _50thPlusSwiper = new Swiper("._50thPlusSwiper", {
      loop: true,
      spaceBetween: 5,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,
        navigation: {
        nextEl: ".banner-button-next",
        prevEl: ".banner-button-prev",
      },
    });
    var _50thPlusSwiper2 = new Swiper("._50thPlusSwiper2", {
      loop: true,
      spaceBetween: 10,
        speed:800,
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
       },
      navigation: {
        nextEl: ".banner-button-next-2",
        prevEl: ".banner-button-prev-2",
      },
      thumbs: {
        swiper: _50thPlusSwiper,
      },
    });

     var popularity_swiper22 = new Swiper("#popularity_swiper", {
      spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".popularity-next-btn2",
          prevEl: ".popularity-pre-btn2",
        },
      });

    var _50thPlusNotice = new Swiper("#_50thPlus-notice_swiper", {
      loop: true,
      spaceBetween: 10,
        speed:800,
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
       },
      navigation: {
        nextEl: ".notice-next",
        prevEl: ".notice-prev",
      },
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-index_old"]) return;
  try {
    
//banner
 var pc_top_swp = new Swiper("#index-top-swp", {
     loop: true,
    slidesPerView: 'auto',
    loopedSlides: 5,
        speed:800,
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
       },
	    spaceBetween: 10,
      freeMode: true,
       navigation: {
          nextEl: ".banner-button-next",
          prevEl: ".banner-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        }
      });

  //min-banner轮播
 /*var index_min_banner_swp = new Swiper("#index-min-banner--swp", {
     loop: true,
      slidesPerView: 2,
      spaceBetween: 10,
        speed:800,
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
       },
      freeMode: true,
      });

      */


    //特集

let feature_swiper_nav = document.getElementById('feature_swiper_nav')
//console.log('feature_swiper_nav',feature_swiper_nav)
let feature_swiper_cont = document.getElementById('feature_swiper_cont')
let dis_swiper_lis = feature_swiper_nav.getElementsByClassName("item")
let feature_items = feature_swiper_cont.getElementsByClassName("feature-item")

for (var i = 0; i < dis_swiper_lis.length; i++) {
let li = dis_swiper_lis[i];
    li.index = i;
    li.onclick = function (e) {
    e.preventDefault()
    for (let k = 0; k < dis_swiper_lis.length; k++) {
        dis_swiper_lis[k].classList.remove('active')
    }
    li.classList.add('active')
    const liNum = li.getAttribute("data-id");

    for (let j = 0; j < feature_items.length; j++) {
        feature_items[j].classList.remove("d-block")
        const contNum = feature_items[j].getAttribute("data-id");
        if(liNum == contNum){
         feature_items[j].classList.add("d-block")
        }
    }

    return false;
    }
}
//特集颜色
var featureColorList = document.getElementsByClassName('featureColorList')

for (let i = 0; i < featureColorList.length; i++) {
    const colorsTextContent = featureColorList[i].querySelector('[type="application/json"]').textContent
    const proColorList = featureColorList[i].querySelector(".proColor--list")
    if(colorsTextContent){
        const colorsData = JSON.parse(colorsTextContent).data
        for (let j = 0; j < colorsData.length; j++){
            let bgColor = colorsData[j].bgColor
            let title = colorsData[j].title
            let isImg = colorsData[j].img
            let border = colorsData[j].border
            let rgbVal = hexToRGB(bgColor)
            var newSpan = document.createElement("span");
            if(border){
            let rgbBorder = hexToRGB(border)
                newSpan.style.boxShadow = `0 0 0 1px rgb(${rgbBorder})`
            }else{
            newSpan.style.boxShadow = `0 0 0 1px rgba(${rgbVal},.6)`
            }
            if(isImg){
                newSpan.style.background = `url(${isImg}) no-repeat 50% 50%/100%`
            }else{
            newSpan.style.backgroundColor = bgColor
            }
            proColorList.appendChild(newSpan);
        }
    }
    




}



var feature_item_swiper_1 = new Swiper("#feature-item_swiper_1", {
spaceBetween: 0,
slidesPerView: "auto",
freeMode: true,
watchSlidesProgress: true,
navigation: {
    nextEl: ".feature-next-btn_1",
    prevEl: ".feature-pre-btn_1",
},
});
var feature_item_swiper_2 = new Swiper("#feature-item_swiper_2", {
spaceBetween: 0,
slidesPerView: "auto",
freeMode: true,
watchSlidesProgress: true,
navigation: {
    nextEl: ".feature-next-btn_2",
    prevEl: ".feature-pre-btn_2",
},
});
var feature_item_swiper_3 = new Swiper("#feature-item_swiper_3", {
spaceBetween: 0,
slidesPerView: "auto",
freeMode: true,
watchSlidesProgress: true,
navigation: {
    nextEl: ".feature-next-btn_3",
    prevEl: ".feature-pre-btn_3",
},
});
var feature_item_swiper_4 = new Swiper("#feature-item_swiper_4", {
spaceBetween: 0,
slidesPerView: "auto",
freeMode: true,
watchSlidesProgress: true,
navigation: {
    nextEl: ".feature-next-btn_4",
    prevEl: ".feature-pre-btn_4",
},
});
var feature_item_swiper_5 = new Swiper("#feature-item_swiper_5", {
spaceBetween: 0,
slidesPerView: "auto",
freeMode: true,
watchSlidesProgress: true,
navigation: {
    nextEl: ".feature-next-btn_5",
    prevEl: ".feature-pre-btn_5",
},
});

var feature_item_swiper_6 = new Swiper("#feature-item_swiper_6", {
spaceBetween: 0,
slidesPerView: "auto",
freeMode: true,
watchSlidesProgress: true,
navigation: {
    nextEl: ".feature-next-btn_6",
    prevEl: ".feature-pre-btn_6",
},
});
  //评论
  var pc_comment = new Swiper('#index_comment', {
    loop: true,
    speed:600,
    autoplay: {
    delay: 3000,
    stopOnLastSlide: false,
     disableOnInteraction: true,
    },
        navigation: {
          nextEl: ".sw-button-next",
          prevEl: ".sw-button-prev",
        },
    })
    //SAIL
     var popularity_swiper = new Swiper("#SAIL_swiper", {
      spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".SAIL-next-btn",
          prevEl: ".SAIL-pre-btn",
        },
      });
    //排行轮播

     var popularity_swiper = new Swiper("#popularity_swiper", {
      spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".popularity-next-btn2",
          prevEl: ".popularity-pre-btn2",
        },
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-files"]) return;
  try {
    
       let filesSwiper = new Swiper("#filesSwiper", {
        spaceBetween: 0,
        loop: true,
        slidesPerView: 'auto',
        loopedSlides: 5,
        speed:800,
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        },
        freeMode: true,
        watchSlidesProgress: true,
         navigation: {
          nextEl: ".customerFeedback-next-btn",
          prevEl: ".customerFeedback-pre-btn",
        },
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-list-collect"]) return;
  try {
    

    //  var popularity_swiper = new Swiper("#popularity_swiper", {
    //   spaceBetween: 0,
    //   slidesPerView: "auto",
    //   freeMode: true,
    //   watchSlidesProgress: true,
    //   navigation: {
    //       nextEl: ".popularity-next-btn",
    //       prevEl: ".popularity-pre-btn",
    //     },
    //   });
 var meanwhile_swiper = new Swiper("#meanwhile_swiper", {
     spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".meanwhile-next-btn",
          prevEl: ".meanwhile-pre-btn",
        },
      });
 var recommend_swiper = new Swiper("#recommend_swiper", {
     spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".recommend-next-btn",
          prevEl: ".recommend-pre-btn",
        },
      });
     var customerFeedback_swiper = new Swiper("#customerFeedback_swiper", {
    spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".customerFeedback-next-btn",
          prevEl: ".customerFeedback-pre-btn",
        },
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bottom"]) return;
  try {
    
 let meanwhile_swiper2 = new Swiper("#meanwhile_swiper2", {
     spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".meanwhile-next-btn",
          prevEl: ".meanwhile-pre-btn",
        },
      });


       let related_product = new Swiper("#related_product", {
     spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".related-next-btn",
          prevEl: ".related-pre-btn",
        },
      });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-grid"]) return;
  try {
    
    let w= document.documentElement.clientWidth
|| document.body.clientWidth;
    const buyEl = document.getElementById('pro_fixed_buy')
    // if(w > 992){
    //  buyEl.style.top = 0
    //  }else{
    //     buyEl.style.top = 'auto'
    //     buyEl.style.bottom = 0
    //  }
//设置产品选项颜色(颜色初始化)
const product_colors = document.getElementById('product_colors')
   const colorsTextContent = product_colors.querySelector('[type="application/json"]').textContent
    if(colorsTextContent){
    const colorsData = JSON.parse(colorsTextContent).data
    const color_block = document.getElementById('product_color_block')
    if(color_block){
    const labels = color_block.querySelectorAll('label')
    for (let i = 0; i < labels.length; i++){
        let isColor = labels[i].dataset.color
        let icon = labels[i].querySelector('.icon')
        for (let j = 0; j < colorsData.length; j++){
            let bgColor = colorsData[j].bgColor
            let title = colorsData[j].title
            let isImg = colorsData[j].img
            let border = colorsData[j].border
            let rgbVal = hexToRGB(bgColor)
             if(isColor.indexOf(title)!=-1){
                if(border){
                  let rgbBorder = hexToRGB(border)
                  labels[i].style.boxShadow = `0 0 0 3px rgb(${rgbBorder})`
                  icon.style.color = `rgb(${rgbBorder})`
                }else{
                labels[i].style.boxShadow = `0 0 0 3px rgba(${rgbVal},.6)`
                }
                if(isImg){
                  labels[i].style.background = `url(${isImg}) no-repeat 50% 50%/100%`
                }else{
                labels[i].style.backgroundColor = bgColor
                }
             }
        }
    }
    }

    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-erwayA03"]) return;
  try {
    
var is_mb = mainCheckMobile()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-nakamichi"]) return;
  try {
    
new WOW().init();
var wow = new WOW({
    boxClass: 'wow',
    animateClass: 'animate__animated',
    offset: 0,
    mobile: true,
    live: true
});
wow.init();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-PHILIPS"]) return;
  try {
    
var is_mb = mainCheckMobile()
const mbSwp = document.getElementsByClassName('philipsSwiper_mb')
const pcSwp = document.getElementsByClassName('philipsSwiper')
if(mbSwp.length){
 let philipsSwiper_mb = new Swiper(".philipsSwiper_mb", {
        spaceBetween: 5,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
      });
      let philipsSwiper_mb2 = new Swiper(".philipsSwiper_mb2", {
        navigation: {
          nextEl: ".to-next",
          prevEl: ".to-prev",
        },
        thumbs: {
          swiper: philipsSwiper_mb,
        },
      });
}
  if(pcSwp.length){
   var philipsSwiper = new Swiper(".philipsSwiper", {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
      });
      var philipsSwiper2 = new Swiper(".philipsSwiper2", {
        navigation: {
          nextEl: ".to-next",
          prevEl: ".to-prev",
        },
        thumbs: {
          swiper: philipsSwiper,
        },
      });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-solemoodPureBox"]) return;
  try {
    
var is_mb = mainCheckMobile()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-UrtopiaEbike1"]) return;
  try {
    
new WOW().init();
var wow = new WOW({
    boxClass: 'wow',
    animateClass: 'animate__animated',
    offset: 0,
    mobile: true,
    live: true
});
wow.init();

  } catch(e) { console.error(e); }
})();
})();
